import { useEffect, useState } from "react";

import getTime from "../helpers/getTime";
import moment from "moment";
import { uniqBy } from "lodash";
import useEvent from "./useEvent";
import useSessions from "./useSessions";

const useArchivedSessions = () => {
  const event = useEvent();
  const sessions = useSessions();
  const [results, setResult] = useState<any>();

  useEffect(() => {
    const results = uniqBy(sessions, "src")
      .filter(
        (session: any) =>
          session.title &&
          !session.title.includes("Break") &&
          !session.private &&
          session.src
      )
      .filter((session: any) => {
        if (event === "SEAADE" && session.timeStart < getTime("26 Nov 2020")) {
          return true;
        } else if (
          event === "IADR" &&
          session.timeStart > getTime("26 Nov 2020")
        ) {
          return true;
        }

        return false;
      })
      .map((item: any) => {
        return {
          ...item,
          title: `${item.title} ${
            item.speaker
              ? `by ${item.speaker.firstname} ${item.speaker.lastname}`
              : ""
          } (Room ${item.room})`,
          subtitle:
            moment(item.timeStart).format("DD MMM YYYY") +
            " | " +
            moment(item.timeStart).format("H:mm") +
            " - " +
            moment(item.timeEnd).format("H:mm"),
          link: `/${event}/sessions/${item.ID}`,
          cover: item.title,
          image: item.image,
        };
      });

    setResult(results);
  }, [event, sessions]);

  return results;
};

export default useArchivedSessions;
